import { useGetUserNotificationsCountQuery } from '@sketch/gql-types';
import { ErrorHandler } from '@sketch/tracing';

// GraphQl
const useGetNewNotificationsCount = (props = {}) => {
    var _a, _b;
    const { fetchPolicy = 'cache-first' } = props;
    const { data } = useGetUserNotificationsCountQuery({
        fetchPolicy,
        onError: error => {
            ErrorHandler.shouldNeverHappen(`Unexpected error fetching me.notifications.meta: '${error.message}'`);
        },
    });
    return (_b = (_a = data === null || data === void 0 ? void 0 : data.me.notifications) === null || _a === void 0 ? void 0 : _a.meta.totalCount) !== null && _b !== void 0 ? _b : 0;
};

export { useGetNewNotificationsCount };
